import { Theme } from '@mui/material';

const endAdornment = {
  'div.MuiInputBase-root.MuiOutlinedInput-root': {
    '& .MuiAutocomplete-endAdornment': {
      top: '18px',
      right: '3px',
      button: {
        '&:hover': {
          backgroundColor: 'transparent',
        },
      },
    },
  },
};

const isDisabled = {
  '&.MuiFormLabel-root.MuiInputLabel-root': {
    color: ({ palette }: Theme) => `${palette.text.placeholder}`,
  },
} as const;

const quotePanelLabel = {
  lineHeight: '17.25px',
  marginBottom: '2px',
};

const baseStyles = {
  '& .MuiAutocomplete-outlined': {
    padding: '8px 12px 8px 12px',
  },
  '& .MuiAutocomplete-icon': {
    width: '10px',
    height: '6px',
    right: '12px',
    top: 'auto',
  },
};

export { endAdornment, baseStyles, isDisabled, quotePanelLabel };
